module.exports = __webpack_public_path__ + "static/img/lp2.66d72b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/brightscreentime/brightscreentime/lp2.png
// module id = 4TGj
// module chunks = 0